angular.module('vcio-toolkit').factory('ClientUtils', function ($location) {
  return {
    getCookieConfig: function () {
      const isDev = nodeenv === 'development';

      const urlSplit = $location.host().split('.');
      let domain;

      if (urlSplit[0].startsWith('localhost')) {
        domain = 'localhost';
      } else {
        domain = urlSplit[1] + '.' + urlSplit[2];
      }

      return {
        domain: domain,
        secure: !isDev,
        sameSite: 'none',
        path: '/',
      };
    }
  };
});